import axios from "axios";
import Links from "../constants/Links";

/**
 * Magic-link (email sign-in) API hooks.
 * `request` is always treated as success in the UI (enumeration-safe).
 */
const MagicLink = {
  request: async (email) => axios.post(Links.magicLink.request, { email }),
  verify: async (token) => axios.post(Links.magicLink.verify, { token }),
};

export default MagicLink;
